/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOClaimHistory from './DTOClaimHistory';
import ClaimHistoryPresenter from './ClaimHistoryPresenter';
import { useAppSelector } from '../../../../infra/hooks';
import { useTranslation } from 'react-i18next';

function ClaimHistoryController() {
  const [allClaimsHistoryData, setAllClaimsHistoryData] = useState([]);
  const [allAirTicketsHistoryData, setAllAirTicketsHistoryData] = useState([]);

  const { t } = useTranslation();
  const [yearFilter, setYearFilter] = useState<number>(0);

  const isLoading = useAppSelector(
    (state) => state.claimHistorySlice.claim_ticketHistoryLoader,
  );

  function callBackFuncAirticketHistory(data: any) {
    setAllAirTicketsHistoryData(data);
  }

  function callBackFuncClaimHistory(data: any) {
    setAllClaimsHistoryData(data);
  }

  const getYearFilter = (year: number) => {
    setYearFilter(year);
  };

  return (
    <>
      <DTOClaimHistory
        setEmpAirTicketHistory={callBackFuncAirticketHistory}
        setEmpClaimHistory={callBackFuncClaimHistory}
        yearFilter={yearFilter}
      />
      <ClaimHistoryPresenter
        claimData={allClaimsHistoryData}
        airTicketsData={allAirTicketsHistoryData}
        setFilterYear={getYearFilter}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default ClaimHistoryController;
